<div style="padding: 24px;">
    <h5 mat-dialog-title class="text-center">Editar usuario</h5>
    <div mat-dialog-content>
        <!--begin::Form-->
        <form class="form" [formGroup]="editUserForm" autocomplete="off" novalidate="novalidate" id="kt_login_form">
        <div class="form-group">
            <mat-form-field class="w-100">
                <mat-label>Nombres</mat-label>
                <input matInput type="text"
                  formControlName="name" autocomplete="off" />
                <mat-error *ngIf="isControlHasError('name', 'required')">
                  <strong>Campo requerido</strong>
                </mat-error>
              </mat-form-field>
            <mat-form-field class="w-100">
                <mat-label>Apellidos</mat-label>
                <input matInput type="text"
                  formControlName="lastname" autocomplete="off" />
                <mat-error *ngIf="isControlHasError('lastname', 'required')">
                  <strong>Campo requerido</strong>
                </mat-error>
              </mat-form-field>
            <mat-form-field class="w-100">
                <mat-label>Cedula</mat-label>
                <input matInput type="number"
                  formControlName="id" autocomplete="off" />
                <mat-error *ngIf="isControlHasError('id', 'required')">
                  <strong>Campo requerido</strong>
                </mat-error>
              </mat-form-field>
            <mat-form-field class="w-100">
                <mat-label>Celular / Telefono</mat-label>
                <input matInput type="text" [textMask]="{mask: mask}"
                  formControlName="userPhone" autocomplete="off" />
                <mat-error *ngIf="isControlHasError('userPhone', 'required')">
                  <strong>Campo requerido</strong>
                </mat-error>
              </mat-form-field>
            <mat-form-field class="w-100">
                <mat-label>Correo electrónico</mat-label>
              <input matInput type="text" style="text-transform:lowercase"
                     formControlName="userEmail" autocomplete="off"/>
                <mat-error *ngIf="isControlHasError('userEmail', 'required')">
                  <strong>Campo requerido</strong>
                </mat-error>
                <mat-error *ngIf="isControlHasError('userEmail', 'email')">
                  <strong>Correo electrónico invalido</strong>
                </mat-error>
            </mat-form-field>
            <div class="w-100 d-flex flex-wrap justify-content-around align-item-center mt-2">
              <button (click)="fileInput.click()" mat-raised-button color="primary" style="height: fit-content;">Subir logo</button>
              <span style="visibility: hidden; position: absolute; overflow: hidden; width: 0px; height:0px;border:none;margin:0; padding:0">
                  <input type="file" #fileInput ng2FileSelect [uploader]="uploader"/>
              </span>
              <mat-spinner diameter="30" class="ml-2" *ngIf="loadingFile"></mat-spinner>
              <p class="m-0 align-self-center"><strong>{{file}}</strong></p>
              <p class="w-100 mb-0 mt-2" [ngClass]="{ 'text-danger': noType }">x pixeles de ancho y y pixeles de alto en formato .png o .jpg</p>
            </div>
        </div>
        </form>
        <!--end::Form-->
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick(false)">Cerrar</button>
        <button mat-button cdkFocusInitial (click)="onNoClick(editUserForm)">Guardar</button>
    </div>
</div>
